import { createColumnHelper, CellContext } from "@tanstack/react-table";
import React, { useState } from "react";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import IAuditoria from "../../../entities/IAuditoria";
import IItemNormativo from "../../../entities/IItemNormativo";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import { deleteAPI, getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserInfo, cognitoUserToken } from "../../../helpers/userHelper";
import {
  ROW_COUNT,
  API_AUDITORIA,
  API_ADMIN_TIPO_DESVIACION,
  URL_SUPPORT,
  API_ADMIN_GRAVEDAD_POTENCIAL,
  API_ADMIN_AMBITO_DESVIACION,
  API_AUDITORIA_POST_HALLAZGOS,
  API_AUDITORIA_GET_HALLAZGOSXITEMNORMATIVA,
  API_AUDITORIA_DELETE_HALLAZGO,
} from "../../../helpers/variableHelper";
import AdminLista from "../../administration/AdminLista";
import Select from "react-select";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { IGravedadPotencial } from "../../../entities/IGravedadPotencial";
import { IAmbitoDesviacion } from "../../../entities/IAmbitoDesviacion";
import { ITipoDesviacion } from "../../../entities/ITipoDesviacion";
import { IComboboxOption } from "../../../entities/helper/IComboboxOption";
import IHallazgos from "../../../entities/IHallazgos";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
import { cParamsActive } from "../../../helpers/paramsHelper";
import { E_GravedadPotencial } from "../../../enums/E_GravedadPotencial";
import { ETipoDesviacion } from "../../../enums/E_TipoDesviacion";

interface IAgregarHallazgosProps {
  items?: Array<IHallazgos>;
  loading?: boolean;
}

export default function AgregarHallazgos({ items, loading = true }: IAgregarHallazgosProps) {
  let search = new URLSearchParams(window.location.search);
  const idAuditoria = parseInt(search.get("idauditoria") || "0");
  const txtItemNormativo = decodeURI(search.get("txtitemnormativo") || "");
  const idItemNormativo = parseInt(search.get("iditemnormativo") || "0");
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(loading);
  const [isSendingData, setIsSendingData] = useState(false);
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [auditoriaSeleccionada] = useState<IAuditoria>();

  const [allTipoDesviacion, setAllTipoDesviacion] = useState<Array<ITipoDesviacion>>([]);
  const [allPotencialidad, setAllPotencialidad] = useState<Array<IGravedadPotencial>>([]);
  const [allPotencialidadObservacion, setAllPotencialidadObservacion] = useState<Array<IGravedadPotencial>>([]);
  const [allAmbitoDesviacion, setAllAmbitoDesviacion] = useState<Array<IAmbitoDesviacion>>([]);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentId = (value: any) => {
    return (
      <div>
        <a
          href="#"
          className="text-decoration-none text-info me-2"
          onClick={(e) => {
            e.preventDefault();
            deleteHallazgo(value.row.original.ID);
          }}>
          <i className="bi bi-x-square-fill iconSearch colorRojo"></i>
        </a>
        <a
          href="#"
          className="text-decoration-none text-info"
          onClick={(e) => {
            e.preventDefault();
            setHallazgoSeleccionado(value.row.original);
            (refTxtProblema.current as HTMLTextAreaElement).value = value.row.original.PROBLEMA;
            setContadorCaracterTxtProblema(value.row.original.PROBLEMA.length);
            (refTxtEvidencia.current as HTMLTextAreaElement).value = value.row.original.EVIDENCIA;
            setContadorCaracterTxtEvidencia(value.row.original.EVIDENCIA.length);
            setValTipoDesvacion({
              value: value.row.original.ID_TIPO_DESVIACION.toString(),
              label: value.row.original.TIPO_DESVIACION,
            });
            setValPotencialidad({
              value: value.row.original.ID_POTENCIALIDAD.toString(),
              label: value.row.original.POTENCIALIDAD,
            });
            setValAmbitoDesviacion({
              value: value.row.original.ID_AMBITO_DESVIACION.toString(),
              label: value.row.original.AMBITO_DESVIACION,
            });
          }}>
          <i className="bi bi-search iconSearch colorAzul"></i>
        </a>
      </div>
    );
  };

  const [allHallazgos, setAllHallazgos] = useState<Array<IHallazgos>>(items || []);

  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [contadorCaracterTxtProblema, setContadorCaracterTxtProblema] = useState(0);
  const [contadorCaracterTxtEvidencia, setContadorCaracterTxtEvidencia] = useState(0);
  const [hallazgoSeleccionado, setHallazgoSeleccionado] = useState<IHallazgos | null>(null);

  const refTxtProblema = React.createRef<HTMLTextAreaElement>();
  const refTxtEvidencia = React.createRef<HTMLTextAreaElement>();

  const [valTipoDesvacion, setValTipoDesvacion] = useState<IComboboxOption | null>(null);
  const [valPotencialidad, setValPotencialidad] = useState<IComboboxOption | null>(null);
  const [valAmbitoDesviacion, setValAmbitoDesviacion] = useState<IComboboxOption | null>(null);

  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    let resultAllTipoDesviacion = (
      await getAPI(
        `${URL_SUPPORT}${API_ADMIN_TIPO_DESVIACION}/getall`,
        { Authorization: `Bearer ${token}` },
        { ...cParamsActive, PAGINADO: ROW_COUNT }
      )
    ).result;
    setAllTipoDesviacion(resultAllTipoDesviacion.data);

    let resultAllPotencialidad = (
      await getAPI(
        `${URL_SUPPORT}${API_ADMIN_GRAVEDAD_POTENCIAL}/getall`,
        { Authorization: `Bearer ${token}` },
        { ...cParamsActive, PAGINADO: ROW_COUNT }
      )
    ).result;
    setAllPotencialidad(resultAllPotencialidad.data);
    let filtroPotencialidadObservacion = resultAllPotencialidad.data.filter(
      (potencialidad: IGravedadPotencial) => potencialidad.ID !== E_GravedadPotencial.Alta
    );
    setAllPotencialidadObservacion(filtroPotencialidadObservacion);

    let resultAllAmbitoDesviacion = (
      await getAPI(
        `${URL_SUPPORT}${API_ADMIN_AMBITO_DESVIACION}/getall`,
        { Authorization: `Bearer ${token}` },
        { ...cParamsActive, PAGINADO: ROW_COUNT }
      )
    ).result;
    setAllAmbitoDesviacion(resultAllAmbitoDesviacion.data);

    let resultGetHallazgos = (
      await getAPI(
        `${API_AUDITORIA}${API_AUDITORIA_GET_HALLAZGOSXITEMNORMATIVA}`,
        { Authorization: `Bearer ${token}` },
        { ...cParamsActive, PAGINADO: ROW_COUNT, ID_ITEM_NORMATIVO: idItemNormativo }
      )
    ).result;
    setAllHallazgos(resultGetHallazgos.data ?? []);
    setIsLoading(false);
    sessionStorage.setItem("agregoHallazgo", "true");
  }, []);

  const filter = async (filters: Partial<IItemNormativo>, page: boolean = false, size = pageSize) => {
    if (!filters) {
      filters = {};
    }
    filters.PAGINADO = size;
    if (filters.PAGINA === undefined) {
      filters.PAGINA = 1;
    }
    if (!page) {
      filters.PAGINA = 1;
    }
    setPage(filters.PAGINA);

    if (filters.ORDENADOPOR === undefined) {
      filters.ORDENADOPOR = "ID";
      filters.ORIENTACION = "DESC";
    }

    let result = (
      await getAPI(
        `${API_AUDITORIA}${API_AUDITORIA_GET_HALLAZGOSXITEMNORMATIVA}`,
        { Authorization: `Bearer ${token}` },
        {
          ...cParamsActive,
          PAGINADO: ROW_COUNT,
          ...filters,
          PAGINA: filters.PAGINA,
          ID_ITEM_NORMATIVO: idItemNormativo,
        }
      )
    ).result;
    setAllHallazgos(result !== undefined ? result.data : []);
    let pages = result !== undefined ? result.pages : 1;
    setPages(pages);
  };

  const deleteHallazgo = async (idHallazgo: number | null) => {
    const url = `${API_AUDITORIA}${API_AUDITORIA_DELETE_HALLAZGO}`;
    setIsLoading(true);
    await deleteAPI(
      url,
      { Authorization: `Bearer ${token}` },
      {
        ID: idHallazgo,
        ID_ITEM_NORMATIVO: idItemNormativo,
      }
    );
    await filter({});
    setIsLoading(false);
  };

  const formValidation = (value: Partial<IHallazgos>): boolean => {
    let arrErrors: Array<string> = [];
    if (!value.ID_TIPO_DESVIACION) {
      arrErrors.push("ID_TIPO_DESVIACION");
    }
    if (!value.ID_POTENCIALIDAD) {
      arrErrors.push("ID_POTENCIALIDAD");
    }
    if (!value.ID_AMBITO_DESVIACION) {
      arrErrors.push("ID_AMBITO_DESVIACION");
    }
    if (!value.PROBLEMA) {
      arrErrors.push("PROBLEMA");
    }
    if (!value.EVIDENCIA) {
      arrErrors.push("EVIDENCIA");
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const saveData = async (): Promise<boolean> => {
    let result = false;
    const value: Partial<IHallazgos> = {
      ID: hallazgoSeleccionado?.ID,
      ID_ITEM_NORMATIVO: idItemNormativo,
      ID_TIPO_DESVIACION: parseInt(valTipoDesvacion?.value as string),
      ID_POTENCIALIDAD: parseInt(valPotencialidad?.value as string),
      ID_AMBITO_DESVIACION: parseInt(valAmbitoDesviacion?.value as string),
      PROBLEMA: (refTxtProblema.current as HTMLTextAreaElement).value,
      EVIDENCIA: (refTxtEvidencia.current as HTMLTextAreaElement).value,
      AUTOR: hallazgoSeleccionado?.ID ? hallazgoSeleccionado?.AUTOR : currentUser?.email,
      AUTOR_DISPLAY: hallazgoSeleccionado?.ID ? hallazgoSeleccionado?.AUTOR_DISPLAY : currentUser?.fullname,
      FECHA_CREACION: new Date(),
      EDITOR: hallazgoSeleccionado?.ID ? currentUser?.email : hallazgoSeleccionado?.EDITOR,
      EDITOR_DISPLAY: hallazgoSeleccionado?.ID ? currentUser?.email : hallazgoSeleccionado?.EDITOR,
      FECHA_MODIFICACION: hallazgoSeleccionado?.ID ? new Date() : hallazgoSeleccionado?.FECHA_MODIFICACION,
    };
    if (formValidation(value)) {
      (refTxtProblema.current as HTMLTextAreaElement).value = "";
      (refTxtEvidencia.current as HTMLTextAreaElement).value = "";
      setContadorCaracterTxtProblema(0);
      setContadorCaracterTxtEvidencia(0);
      setValTipoDesvacion(null);
      setValPotencialidad(null);
      setValAmbitoDesviacion(null);
      setHallazgoSeleccionado(null);
      setIsLoading(true);
      setIsSendingData(true);
      let v = (await postAPI(`${API_AUDITORIA}${API_AUDITORIA_POST_HALLAZGOS}`, value, { Authorization: `Bearer ${token}` })).result;
      console.log(v);
      result = true;
    }

    return result;
  };

  const columnHelperMantIncCausa = createColumnHelper<IHallazgos>();
  let columnsDef = [
    columnHelperMantIncCausa.accessor((row) => row.TIPO_DESVIACION, {
      id: "TIPO_DESVIACION",
      cell: (info: CellContext<IHallazgos, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Desviación"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.AMBITO_DESVIACION, {
      id: "AMBITO_DESVIACION",
      cell: (info: CellContext<IHallazgos, string>) => componentValue(info.getValue()),
      header: () => component("Ámbito"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.PROBLEMA, {
      id: "PROBLEMA",
      cell: (info: CellContext<IHallazgos, string>) => componentValue(info.getValue()),
      header: () => component("Problema"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.EVIDENCIA, {
      id: "EVIDENCIA",
      cell: (info: CellContext<IHallazgos, string>) => componentValue(info.getValue()),
      header: () => component("Evidencia"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ID, {
      id: "ID",
      cell: (
        info: CellContext<IHallazgos, string> //
      ) => componentId(info),
      header: () => component("Opciones"),
      tipo: ITipo_Campo.text,
      hideFilter: true,
    } as any),
  ] as any;
  return (
    <div className="row">
      <button
        data-testid="btntest"
        hidden={true}
        onClick={() => {
          deleteHallazgo(1);
        }}></button>
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container-fluid mb-4">
            <h1 className="titPrincipal colorTit">Auditoría</h1>

            <div className="card bg-light border p-3 pt-2 mt-2">
              <div className="row ajusteInput">
                <div className="col-12">
                  <h6>
                    <span className="textSeccion">Hallazgo</span>
                  </h6>
                </div>
                <div className="col-12 mb-2">
                  <AdminLista
                    hideAdd={true}
                    hideExport={true}
                    data={allHallazgos}
                    callback={() => {}}
                    reload={filter}
                    filter={filter}
                    pagination={{
                      pages: pages,
                      page: page,
                      paging: filter,
                    }}
                    tipo="Programaciones"
                    columnsDef={columnsDef}
                    isLoading={isLoading}
                    callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                      setPageSize(pageSize);
                      filter(filters, false, pageSize);
                    }}
                  />
                </div>
                <div className="row">
                  <div>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary me-1"
                      disabled={isSendingData}
                      onClick={async () => {
                        let f = await saveData();
                        if (f) {
                          filter({});
                          setIsLoading(false);
                          setIsSendingData(false);
                        }
                      }}>
                      Agregar
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      disabled={isSendingData}
                      onClick={async () => {
                        window.location.href = `planInforme?id=${idAuditoria}`;
                      }}>
                      Continuar
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="row ajusteInput">
                    <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                      <label>Ítem Normativo</label>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                      <label>{txtItemNormativo}</label>
                    </div>
                  </div>
                  <div className="row ajusteInput">
                    <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                      <label>
                        <span className="text-danger">(*)</span> Tipo de Desviación
                      </label>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                      <Select
                        placeholder="Seleccione"
                        className={`${arrErrorEmpty.includes("ID_TIPO_DESVIACION") && "error"}`}
                        isClearable={true}
                        noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                        options={allTipoDesviacion.map((i) => ({
                          value: i.ID,
                          label: i.NOMBRE,
                        }))}
                        value={valTipoDesvacion || {}}
                        onChange={(e: any) => {
                          setValTipoDesvacion(e);
                          if (e.value === ETipoDesviacion.NoConformidad) {
                            setValPotencialidad({
                              label: "Alta",
                              value: E_GravedadPotencial.Alta.toString(),
                            });
                          } else if (e.value === ETipoDesviacion.OportunidadMejora || e.value === ETipoDesviacion.Conformidad) {
                            setValPotencialidad({
                              label: "Baja",
                              value: E_GravedadPotencial.Baja.toString(),
                            });
                          } else {
                            setValPotencialidad(null);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="row ajusteInput">
                    <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                      <label>
                        <span className="text-danger">(*)</span> Potencialidad
                      </label>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                      {valTipoDesvacion?.value.toString() === ETipoDesviacion.Observacion.toString() ? (
                        <Select
                          placeholder="Seleccione"
                          className={`${arrErrorEmpty.includes("ID_POTENCIALIDAD") && "error"}`}
                          isClearable={true}
                          noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                          options={allPotencialidadObservacion.map((i) => ({
                            value: i.ID,
                            label: i.TITULO,
                          }))}
                          value={valPotencialidad || {}}
                          onChange={async (e: any) => {
                            setValPotencialidad(e);
                          }}
                          isDisabled={
                            valPotencialidad?.value === E_GravedadPotencial.Alta.toString() ||
                            valPotencialidad?.value === E_GravedadPotencial.Baja.toString()
                              ? true
                              : false
                          }
                        />
                      ) : (
                        <Select
                          placeholder="Seleccione"
                          className={`${arrErrorEmpty.includes("ID_POTENCIALIDAD") && "error"}`}
                          isClearable={true}
                          noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                          options={allPotencialidad.map((i) => ({
                            value: i.ID,
                            label: i.TITULO,
                          }))}
                          value={valPotencialidad || {}}
                          onChange={async (e: any) => {
                            setValPotencialidad(e);
                          }}
                          isDisabled={
                            valPotencialidad?.value === E_GravedadPotencial.Alta.toString() ||
                            valPotencialidad?.value === E_GravedadPotencial.Baja.toString()
                              ? true
                              : false
                          }
                        />
                      )}
                    </div>
                  </div>
                  <div className="row ajusteInput">
                    <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                      <label>
                        <span className="text-danger">(*)</span> Ámbito desviación
                      </label>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                      <Select
                        placeholder="Seleccione"
                        className={`${arrErrorEmpty.includes("ID_AMBITO_DESVIACION") && "error"}`}
                        isClearable={true}
                        noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                        options={allAmbitoDesviacion.map((i) => ({
                          value: i.ID,
                          label: i.TITULO,
                        }))}
                        value={valAmbitoDesviacion || {}}
                        onChange={async (e: any) => {
                          setValAmbitoDesviacion(e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row ajusteInput">
                    <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                      <label>
                        <span className="text-danger">(*)</span> Problema
                      </label>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                      <textarea
                        className={`form-control form-control-sm w-50 ${arrErrorEmpty.includes("PROBLEMA") && "error"}`}
                        rows={3}
                        data-testId="textbox2"
                        ref={refTxtProblema}
                        defaultValue={auditoriaSeleccionada?.OBJETIVO_ALCANCE_EXCLUSIONES}
                        onChange={() => setContadorCaracterTxtProblema(refTxtProblema.current?.value.length || 0)}
                        maxLength={2000}></textarea>
                      <span>{contadorCaracterTxtProblema}/2000</span>
                    </div>
                  </div>
                  <div className="row ajusteInput">
                    <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                      <label>
                        <span className="text-danger">(*)</span> Evidencia
                      </label>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                      <textarea
                        data-testId="textbox"
                        className={`form-control form-control-sm w-50 ${arrErrorEmpty.includes("EVIDENCIA") && "error"}`}
                        rows={3}
                        ref={refTxtEvidencia}
                        defaultValue={auditoriaSeleccionada?.OBJETIVO_ALCANCE_EXCLUSIONES}
                        onChange={() => setContadorCaracterTxtEvidencia(refTxtEvidencia.current?.value.length || 0)}
                        maxLength={2000}></textarea>
                      <span>{contadorCaracterTxtEvidencia}/2000</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
